<template>
    <div class="account-data" v-loading="loading">
        <div class="account-data__content">
            <div class="account-data__block">
                <div class="label">Опыт работы</div>

                <ModelCheckbox class="" v-model="profileInfo.isNoWorkExperience" label="Нет опыта работы" />
            </div>

            <template v-if="!profileInfo.isNoWorkExperience">
                <div v-for="(_, index) in careers" class="account-data__item" :key="index">
                    <div class="delete-block">
                        <div class="delete-block__btn" @click="rmJob(careers[index], index)">
                            {{ deleteBlockText }}<span>+</span>
                        </div>
                    </div>
                    <WideCareerJob v-model="careers[index]"></WideCareerJob>
                </div>
            </template>

            <div class="add-block-btn" :class="[
                { disabled: profileInfo.isNoWorkExperience },
                { 'add-block-btn--mt': careers.length },
            ]" @click="addJob">
                Добавить место работы
            </div>
        </div>
        <FixedSaveBtn v-if="showFixedSaveBtn" @close="closeFixedBtn">
            <ActionButton @b-action="saveData" :b-color="saveButton.color" b-t-color="white"
                :b-text="saveButton.fixedText" class="save-block__btn--position save-block__btn" />
        </FixedSaveBtn>
        <div class="save-block">
            <ActionButton ref="careerBtn" @b-action="saveData" :b-color="saveButton.color" b-t-color="white"
                :b-text="saveButton.text" class="save-block__btn--position save-block__btn" />
        </div>
    </div>
</template>

<script>
import WideCareerJob from './WideCareerJob';
import FixedSaveBtn from '../FixedSaveBtn';
import ActionButton from '@/components/UI/inputs/ActionButton';
import ModelCheckbox from '@/components/UI/models/ModelCheckbox';

import { mapActions, mapGetters } from 'vuex';
import { get } from '@/tools/http';

const getters = ['userProfileInfo', 'getCareers', 'isMobile', 'dictionaryByType'];
const actions = [
    'postProfileData',
    'loadCareers',
    'addCareers',
    'updateCareer',
    'removeCareer',
    'loadDictionaryItems',
];
const professionsActions = ['loadProfession', 'loadAllProfession'];
const professionsGetters = ['getAllProfession'];

export default {
    name: 'WideCareerData',
    components: {
        WideCareerJob,
        ActionButton,
        ModelCheckbox,
        FixedSaveBtn,
    },
    data: () => ({
        fixedClosedByBtn: false,
        showFixedSaveBtn: false,
        observer: null,
        profileInfo: {
            desiredArea: [],
            desiredProfession: [],
            isNoWorkExperience: false,
        },
        careers: [],
        loading: false,
        saveButton: {
            fixedText: 'Сохранить изменения',
            text: 'Сохранить',
            color: '#4663AB',
            status: 'wait',
        },
        autoCompleteDesiredProfession: [],
        selectedDesiredProfession: [],
        autoCompleteActivity: [],
        selectedActivity: [],
    }),
    computed: {
        ...mapGetters(getters),
        ...mapGetters('professions', professionsGetters),

        deleteBlockText() {
            return this.isMobile ? 'Удалить блок' : 'Удалить добавленный блок';
        },
    },
    async created() {
        let userProfileInfo = JSON.parse(JSON.stringify(this.userProfileInfo));

        this.profileInfo.desiredArea = userProfileInfo['desiredArea'];
        this.profileInfo.desiredProfession =
            userProfileInfo['desiredProfession'];
        this.profileInfo.isNoWorkExperience =
            userProfileInfo['isNoWorkExperience'];
        await this.loadDictionaryItems("wl_organization");
    },
    async mounted() {
        this.loading = true;
        await this.loadCareers();
        this.careers = this.getCareers;
        await this.loadAllActivities();
        if (this.profileInfo.desiredArea) {
            this.selectedActivity = this.profileInfo.desiredArea;
        }
        this.loading = false;
        // загрузка желаемых профессий
        // this.loadSelectedDesiredProfession();
        // await this.loadAllProfession();
        // this.autoCompleteDesiredProfession = this.getAllProfession;
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                !entry.isIntersecting && Math.sign(entry.boundingClientRect.top) === 1 ? this.showFixedSaveBtn = true : this.showFixedSaveBtn = false;
            });
        });
        this.$watch('profileInfo', () => {
            this.observer.observe(this.$refs.careerBtn.$el);
        }, { deep: true });
        this.$watch('careers', () => {
            this.observer.observe(this.$refs.careerBtn.$el);
        }, { deep: true });
    },
    beforeDestroy() {
        this.observer ? this.observer.disconnect() : '';
    },
    methods: {
        ...mapActions(actions),
        closeFixedBtn() {
            this.showFixedSaveBtn = false;
            this.observer ? this.observer.disconnect() : '';
        },
        ...mapActions('professions', professionsActions),
        async addJob() {
            if (this.profileInfo.isNoWorkExperience) return;
            await this.addCareers();
        },
        async rmJob(career, index) {
            await this.removeCareer({ career: career, index: index });
        },
        async saveData() {
            if (this.saveButton.status !== 'wait') return;
            this.saveButton.status = 'wait';
            this.saveButton.color = '#4663AB';
            this.saveButton.text = 'Сохранение...';
            this.saveButton.fixedText = 'Сохранение...';

            try {
                await this.postProfileData(this.profileInfo);

                const promises = [];
                this.careers.forEach((car, index) => {
                    const {
                        isStateOrganization,
                        fgoOrganization,
                        organizationInn,
                        isNotFgoOrganizationFromCatalog,
                        ...rest
                    } = car;

                    let career;

                    if (isStateOrganization === undefined) {
                        career = { ...rest };
                    } else {
                        career = {
                            ...rest,
                            fgoOrganization: undefined,
                            ...(isStateOrganization
                                ? {
                                    isNotFgoOrganizationFromCatalog,
                                    organisation: !isNotFgoOrganizationFromCatalog && fgoOrganization && fgoOrganization.field_value || null,
                                    organizationInn: isNotFgoOrganizationFromCatalog ? organizationInn : null,
                                }
                                : {
                                    isNotFgoOrganizationFromCatalog: null,
                                    organizationInn: null,
                                }
                            ),
                        };
                    }

                    promises.push(
                        this.updateCareer({ car: career, index: index })
                    );
                });
                await Promise.all(promises);
                this.saveButton.status = 'wait';
                this.saveButton.color = '#238C47';
                this.saveButton.text = 'Данные сохранены';
                this.saveButton.fixedText = 'Данные сохранены';
                this.showFixedSaveBtn = false;
                this.observer ? this.observer.disconnect() : '';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            } catch (e) {
                console.error(e);
                this.saveButton.status = 'wait';
                this.saveButton.color = '#F7E9F1';
                this.saveButton.text = 'Ошибка! извините..';
                this.saveButton.fixedText = 'Ошибка! извините..';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            }
        },
        // async getAutocompleteDesiredProfession(inputObj) {
        //     if (inputObj.value.length >= 1) {
        //         this.autoCompleteDesiredProfession =
        //             this.getAllProfession.filter(p => ~p.name.toLowerCase().search(inputObj.value.toLowerCase()));
        //     } else {
        //         this.autoCompleteDesiredProfession = this.getAllProfession;
        //     }
        // },
        // async loadSelectedDesiredProfession() {
        //     if (this.profileInfo.desiredProfession) {
        //         this.selectedDesiredProfession = (await Promise.all(
        //             this.profileInfo.desiredProfession
        //                 .map(v => this.loadProfession(v))
        //         )).map(p => p.profiles).flat();
        //         // https://progress.rsv.ru/profiles?filter[status]=published
        //     }
        // },
        async loadAllActivities() {
            this.autoCompleteActivity = (await this.dictionaryByType(
                'industries'
            )).map(i => i.field_value);
        },
        async getAutocompleteActivity(inputObj) {
            if (inputObj.value.length > 0) {
                const list = await this.dictionaryAutocomplete({
                    type: 'industries',
                    search: inputObj.value,
                });
                this.autoCompleteActivity = list.map(i => i.field_value);
            } else {
                this.autoCompleteActivity = (await this.dictionaryByType(
                    'industries'
                )).map(i => i.field_value);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';
</style>
